import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface IInitialState {
  storyName: string | null | undefined;
  editName: string | null | undefined;
}

const initialState: IInitialState = {
  storyName: null,
  editName: null,
};

const breadcumbSlice = createSlice({
  name: 'breadcumbSlice',
  initialState,
  reducers: {
    setStoryName: (state, action: PayloadAction<string | undefined | null>) => {
      state.storyName = action.payload;
    },
    removeStoryName: (state) => {
      state.storyName = null;
    },
    setEditName: (state, action: PayloadAction<string | undefined | null>) => {
      state.editName = action.payload;
    },
    removeEditName: (state) => {
      state.editName = null;
    },
  },
});
export const { setStoryName, removeStoryName, setEditName, removeEditName } =
  breadcumbSlice.actions;
export default breadcumbSlice.reducer;
